exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-stock[data-v-d7d03ff8] {\r\n  height:40px;\r\n  line-height:40px;\r\n  text-align:center;\r\n  width:100%;\r\n  color: #999;\n}\n.b_top[data-v-d7d03ff8] {\r\n  border-top: 1px solid #e5e5e5;\n}\r\n", ""]);

// exports
